export default __webpack_public_path__ + "static/media/harangi_dam.da65191c.jpg";